// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"871ed923","732":"1224cfa6","977":"27b45144"}[chunkId] + ".chunk.js");